// import * as types from './mutation-type'
export default {
  setAct (state, obj) {
    state.actInfo = obj
  },
  setLottery (state, bol) {
    state.is_Lottery = bol
  },
  setShareId (state, str) {
    state.shareId = str
  },
  setOverTime (state, bol) {
    state.overTime = bol
  },
  setCardInfo (state, obj) {
    state.cardInfo = obj
  },
  setBless (state, str) {
    state.blessId = str
  },
  setMusic (state, bol) {
    state.showMusic = bol
  }
}
